module.exports = __webpack_public_path__ + "static/media/bigLogo.1e792a2b.png";